import React from 'react';
import { Nullable } from 'global';
import { useHistory } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { BpfCloseReasonType } from '../../../types';
import { closeReasonsMapper } from '../../../mappers';
import { GetCloseReasonsResponse } from '../../../api';
import { CloseReasonSection } from './CloseReasonSection';

interface Props {
  flowId: string;
  reasons: Nullable<GetCloseReasonsResponse>;
}

export const CloseReasonConfiguration = ({ reasons, flowId }: Props) => {
  const { goBack } = useHistory();

  const mappedReasons = closeReasonsMapper.processReasonsToFormValues(reasons ?? null);

  return (
    <CardContainer>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', height: '100%' }}>
        <CloseReasonSection flowId={flowId} reasons={mappedReasons.won} type={BpfCloseReasonType.Won} />
        <CloseReasonSection flowId={flowId} reasons={mappedReasons.lost} type={BpfCloseReasonType.Lost} />
      </Box>

      <Stack direction="row" gap="1rem">
        <Button onClick={goBack} size="large">
          Back
        </Button>
      </Stack>
    </CardContainer>
  );
};
